import { EModalSource } from 'shared/common/types/modal';
import { TApplicationState } from 'shared/common/types/redux';

export const selectModalSource = (state: TApplicationState): EModalSource | undefined => {
  return state.modalStatus.source;
};
